<template>
  <v-form @submit="updateName" ref="form">
    <v-layout wrap>
      <v-flex sm10>
        <v-text-field v-model="name" :rules="requiredRule"></v-text-field>
      </v-flex>
      <v-flex sm1 mt-2 pl-6>
        <v-btn @click="updateName" text icon color="grey">
          <v-icon large>mdi-pencil</v-icon>
        </v-btn>
      </v-flex>
      <v-flex sm1 mt-2 pl-2>
        <v-btn
          @click="dialogDelete = true"
          text
          icon
          color="grey"
          class="d-flex justify-center align-center"
        >
          <v-icon text icon color="grey" large>mdi-close</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

    <!-- Ventana para eliminar -->
    <v-dialog v-model="dialogDelete" width="50%">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Eliminar opción</v-card-title>

        <v-card-text class="title">¿Estás seguro de eliminar esta opción?</v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="dialogDelete = false">cancelar</v-btn>
          <v-btn color="primary" text @click="deleteOption">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" top right>
      {{ message }}
      <v-btn color="pink" text @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
  </v-form>
</template>

<script>
import axios from "axios";
export default {
  name: "OptionName",
  props: {
    option: Object
  },
  data() {
    return {
      requiredRule: [v => !!v || "Este campo es obligatorio"],
      dialogDelete: false,
      name: this.option.name,
      snackbar: false,
      message: "",
      host: process.env.VUE_APP_HOST
    };
  },
  methods: {
    updateName() {
      let data = {
        idOption: this.option.idOption,
        name: this.name,
        idUserVerify: sessionStorage.getItem("authorization")
      };

      axios
        .post(
          this.host + "/personaldataoptions/optionname/update.php",
          this.createFormData(data)
        )
        .then(response => {
          this.personalDataName = "";
          this.message = response.data.message;
          this.dialogDelete = false;
          this.snackbar = true;
          this.$emit("updateOptions");
        })
        .catch(error => {
          console.log(error);
        });
    },
    deleteOption() {
      let data = {
        idOption: this.option.idOption,
        idUserVerify: sessionStorage.getItem("authorization")
      };

      axios
        .post(
          this.host + "/personaldataoptions/optionname/delete.php",
          this.createFormData(data)
        )
        .then(response => {
          this.personalDataName = "";
          this.message = response.data.message;
          this.dialogDelete = false;
          this.snackbar = true;
          this.$emit("updateOptions");
        })
        .catch(error => {
          console.log(error);
        });
    },
    createFormData(postData) {
      let formDa = new FormData();
      for (let key in postData) {
        formDa.append(key, postData[key]);
      }
      return formDa;
    }
  }
};
</script>